import { render, staticRenderFns } from "./NodesAttr.vue?vue&type=template&id=796051b9&scoped=true&"
import script from "./NodesAttr.vue?vue&type=script&lang=js&"
export * from "./NodesAttr.vue?vue&type=script&lang=js&"
import style0 from "./NodesAttr.vue?vue&type=style&index=0&id=796051b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796051b9",
  null
  
)

export default component.exports